import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

import Menu from '../../components/Menu/Menu';



class Layout extends Component { 

    state = {
        showMenu: false,
    }

    toggleMenu = () => {
        const newValue = !this.state.showMenu;
        this.setState({ showMenu: newValue });
    }

    handleLogoClick = () => {
        const {dispatch} = this.props;
        dispatch(push('/'));
    }

    render(){

        let mainContentStyle = {
            'transition' :  'transform 0.3s cubic-bezier(.1, .4, .1 , 1)',
            'transform': this.state.showMenu ? 'scale(0.95)': 'none'
        }

        return (
            
            <div>
               <Menu key="menu" toggleAction={this.toggleMenu} showMenu={this.state.showMenu} />
               <div key="main" className={[this.props.layoutClass].join('')} style={mainContentStyle}>
                { 
                  React.Children.map(this.props.children, child => {
                    if (child === null) return null;
                    if(child.type.name==="footer"){
                        return React.cloneElement(child, {
                            onToggleMenu: this.toggleMenu
                        });
                    }
                    else if(child.type.name==="header"){
                        return React.cloneElement(child, {
                            onLogoClick : this.handleLogoClick
                        });
                    }else{
                        return React.cloneElement(child);  
                    }
                  })
                }
                {/* this.props.children */}

               </div>
            </div>
        )

    }
}

export default connect()(Layout);


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js